import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {BaseComponent} from '../BaseComponent';
import {ProviderModel} from '../../models/ProviderModel';

@Component({
  selector: 'app-reporting',
  templateUrl: './reporting.component.html',
  styleUrls: ['./reporting.component.scss']
})
export class ReportingComponent extends BaseComponent implements OnInit {

  filterPageReportList: any;

  constructor(private http: HttpClient, router: Router, route: ActivatedRoute) {
    super(route, router);
    const providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.filterPageReportList =
      providerSelect.cod === this.PROVIDER_DXC ? this.LINKS.FILTER_PAGE_REPORT_DXC : this.LINKS.FILTER_PAGE_REPORT_IBM;
  }

  ngOnInit() {
  }

  returnReporting(url: string, pathRelative: string) {
    if (url.includes('/reporting' + pathRelative)) {
      this.router.navigate(['/reporting']);
    } else {
      this.router.navigate(['/reporting' + pathRelative], { queryParams: { reportSection: true }});
    }
  }

  returnZero() {
    return 0;
  }

}
